<template>
  <div>
    <b-card no-body>
      <b-card-body title="جزییات مشتری">
        <hr class="my-4" />
        <br />
        <b-card-text>
          <b-row>
            <b-col>
              <b-form-group
                id="example-input-group-1"
                label="تاریخ ثبت نام:"
                label-for="example-input-1"
              >
                <b-form-input
                  id="input-4"
                  :disabled="true"
                  v-model="user.created_at"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="example-input-group-1"
                label="نوع:"
                label-for="example-input-1"
              >
                <MDDropdown
                  :disabled="true"
                  v-bind:group="17"
                  v-model="user.mdid17_merchant_type"
                ></MDDropdown>
                <b-form-invalid-feedback id="input-1-live-feedback"
                  >وارد کردن نام اجباری است</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>
          <div v-if="user.mdid17_merchant_type == 1550">
            <PersonInfo v-model="user" v-bind:disabled="true"></PersonInfo>
          </div>
          <div v-if="user.mdid17_merchant_type == 1551">
            <CompanyInfo v-model="user" v-bind:disabled="true"></CompanyInfo>
          </div>
          <h4>اطلاعات تماس</h4>
          <UserAddress v-model="user" v-bind:disabled="true"></UserAddress>
        </b-card-text>
      </b-card-body>
      <b-card-body title="وضعیت تاییدیه ها">
        <hr class="my-4" />
        <br />
        <b-card-text>
          <list-table
            :url="userconf.url"
            title="وضعیت تاییدیه ها"
            :detailUrl="userconf.detailUrl"
            :fields="userconf.fields"
            :params="userconf.params"
          ></list-table>
        </b-card-text>
      </b-card-body>
      <b-card-body title="درگاه ها">
        <hr class="my-4" />
        <br />
        <b-card-text>
          <list-table
            :url="merchats.url"
            title="لیست درگاه ها"
            :detailUrl="merchats.detailUrl"
            :fields="merchats.fields"
            :params="merchats.params"
          ></list-table>
        </b-card-text>
      </b-card-body>
      <b-card-body title="شماره شبا تسویه">
        <hr class="my-4" />
        <br />
        <b-card-text>
          <list-table
              :url="settelmentsheba.url"
              title="لیست شباهای تسویه"
              :fields="settelmentsheba.fields"
              :params="settelmentsheba.params"
            ></list-table>
        </b-card-text>
      </b-card-body>
    </b-card>
  </div>
</template>
<style>
.sc-card-pan {
  direction: ltr;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import MDDropdown from "../../components/MDDropdown";
import persianDate from "../../helpers/persianDate";
import httpHelper from "../../helpers/httpHelper";
import PersonInfo from "../Users/PersonInfo";
import CompanyInfo from "../Users/CompanyInfo";
import UserAddress from "../Users/UserAddress";
export default {
  name: "ViewClientDetails",
  data() {
    return {
      user: {},
      trDetail: { location: { countryCode: "IR" } },

      gateways: [],
      merchats: {
        url: "paymentgateways?user_id=" + this.$route.params.id,
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "website_name",
            label: "نام وبسایت",
          },
          {
            key: "website_en_name",
            label: "نام انگلیسی",
          },
          {
            key: "website",
            label: "آدرس",
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [],
        detailUrl: "editGateway",
      },
      settelmentsheba: {
        url: "settelmentsheba?user_id=" + this.$route.params.id,
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "nickname",
            label: "نام مالک",
          },
          {
            key: "shaba_number",
            label: "شماره شبا",
          },
         {
            key: "account_number",
            label: "شماره حساب",
          },  
         
          {
            key: "bank_name.title",
            label: "نام بانک",
          },
           {
            key: "status.title",
            label: "وضعیت",
          },
         
        ],
        params: [
        ],
      },
      userconf: {
        url: "userconf?user_id=" + this.$route.params.id,
        fields: [
          {
            key: "id",
            label: "کد",
          },
          {
            key: "type.title",
            label: "برای",
          },
          {
            key: "status.title",
            label: "وضعیت",
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [],
        detailUrl: "editUserConf",
      },
    };
  },
  components: {
    "list-table": TableShowData,
    MDDropdown,
    PersonInfo,
    CompanyInfo,
    UserAddress,
  },
  created() {
    httpHelper.setAuth();
  },
  methods: {
    LoadGateways() {
      httpHelper
        .getData("paymentgateways?p=not&user_id=" + this.$route.params.id)
        .then((response) => {
          this.gateways = response.result.map(function (o) {
            return {
              text: o.website_name,
              value: o.id,
            };
          });
        });
    },
  },
  mounted() {
    httpHelper.getData("users?id=" + this.$route.params.id).then((res) => {
      console.log(res);
      this.user = res.result;
      if (this.user.created_at != null) {
        this.user.created_at = persianDate.getDateByFormat(this.user.created_at);
      } else {
        this.user.created_at = "-";
      }
    });
    this.$store.dispatch(SET_BREADCRUMB, [
      {
         title: "لیست مشترکین",
        route: "/clients",
      },
      {
        title: "جزییات مشترکین",
      },
    ]);
  },
};
</script>